import { Component, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { BbTableService, BbTableSelectOption } from '../../../services/bb-table.service';
import { FilterSetService } from '../../../services/filter-set.service';
import { AbstractListComponent } from '../../shared/abstract-list.component';
import { Publication } from '../../../interfaces/publication';
import { PublicationService } from '../../../services/publication.service';
import { DateRange } from '../../../interfaces/dateRange';
import { AdServicesService } from '../../../services/ad-services.service';

@Component({
	selector: 'lineitem-list',
	templateUrl: './lineitem-list.component.html',
	styleUrls: ['./lineitem-list.component.scss'],
	providers: [BbTableService, FilterSetService],
})

export class LineitemListComponent extends AbstractListComponent implements AfterViewInit {
	// TODO: Implement minDate
	minDate: Date;

	statsDate: DateRange;
	stats: any[];

	publication: Publication;

	newDataFromDate: Date;

	constructor(
		protected bbTableService: BbTableService,
		protected filterSetService: FilterSetService,
		protected publicationService: PublicationService,
		public adServicesService: AdServicesService,
		private changeDetector: ChangeDetectorRef) {
		super(bbTableService, filterSetService);

		this.listConfiguration = {
			name: 'lineitem',
			basePath: '/adservices/lineitems/',
			activePath: '/adservices/lineitems',
			entityTranslation: this.translate.instant('LINEITEM').toLowerCase(),
			entitiesTranslation: this.translate.instant('LINEITEMS').toLowerCase()
		};

		this.filterConfig = {
			search: true,
			filters: [
				{
					property: 'title',
					label: this.translate.instant('TITLE'),
					type: 'text'
				},
				{
					property: 'code',
					label: this.translate.instant('CODE'),
					type: 'text'
				},
				{
					property: 'status',
					label: this.translate.instant('STATUS'),
					type: 'select'
				},
				{
					property: 'createdBy',
					label: this.translate.instant('CREATED_BY'),
					type: 'select'
				}, {
					property: 'updatedBy',
					label: this.translate.instant('UPDATED_BY'),
					type: 'select'
				}, {
					property: 'createddate',
					label: this.translate.instant('CREATED_DATE'),
					type: 'date'
				},
				{
					property: 'updateddate',
					label: this.translate.instant('UPDATED_DATE'),
					type: 'date'
				}
			],
			presets: [
				{
					label: this.translate.instant('ALL'),
					value: 'all',
					filterSet: [],
				},
				{
					label: this.translate.instant('ACTIVE'),
					value: 'published',
					filterSet: [{
						filters: [{
							type: 'lineitem',
							field: 'status',
							operator: 'is',
							value: 'published'
						}]
					}],
				},
				{
					label: this.translate.instant('INACTIVE'),
					value: 'draft',
					filterSet: [{
						filters: [{
							type: 'lineitem',
							field: 'status',
							operator: 'is',
							value: 'draft'
						}]
					}],
				}
			]
		};

		this.newDataFromDate = new Date('2018-07-16T14:00:00.000Z');

		this.subscriptions.add(
			this.publicationService.getData().subscribe((publication: Publication) => {
				if (publication) {
					this.publication = publication;
				}
			})
		);

		const baseFilter = [{
			filters: [{
				type: 'lineitem',
				field: 'isVMAP',
				operator: 'is',
				value: ['false']
			}]
		},{
			filters: [{
				type: 'lineitem',
				field: 'subtype',
				operator: 'isNot',
				value: ['auction']
			}]
		}];

		this.bbTableService
			.setSelect(BbTableSelectOption.none)
			.setBaseFilterSet(baseFilter)
			.setLimit(15)
			.linkToUrl();
	}

	ngAfterViewInit() {
		this.changeDetector.detectChanges();
	}

	datesChanged(dateRange: DateRange) {
		this.statsDate = dateRange;
	}
}
